import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import { Box, Typography, Button, FormHelperText } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import { useFormik } from "formik";
import { verifyOTPRoute, resendOTPRoute } from "../../routes/apiRoutes";
import { useLocation, useNavigate } from "react-router";
import { toast } from "react-toastify";
import { resetPasswordRoute } from "../../routes/reactRoutes";
import UnAuthorized from "../commonControls/UnAuthorized";
import { LogoAndText } from "../../theme/JaziTheme";
import { MuiOtpInput } from "mui-one-time-password-input";
import { LoadingButton } from "@mui/lab";
import axiosInstance from "../../axios/axiosInstance";
import { t } from "i18next";
import FlipLanguageSwitcher from "./FlipLanguageSwitcher";

const OTPVerify = (props) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = React.useState("");
  const [time, setTime] = React.useState(0);
  const [linkDisable, setLinkDisabled] = useState(true);
  const { state } = useLocation();
  const email = state?.email;

  const handleChange = (newValue) => {
    setOtp(newValue);
  };
  useEffect(() => {
    document.title = props.title;
    handleTimer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleTimer = async () => {
    let i = 59;
    const interval = setInterval(() => {
      if (i < 1) {
        setLinkDisabled(false);
        clearInterval(interval);
      } else {
        setTime(i);
        i--;
      }
    }, 1000);
  };
  const handleResendRequest = async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(`${resendOTPRoute}${email}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (data.statusCode === 200 || data.statusCode === 201) {
        toast.dismiss();
        toast.success(t("otpsendsuccess"), { autoClose: 1000 });
        setLinkDisabled(true);
        setLoading(false);
        handleTimer();
      } else {
        toast.dismiss();
        toast.error(t("unexpectedserverresponse"), { autoClose: false });
        setLoading(false);
      }
    } catch (error) {
      toast.error(t("otpsenderror"), {
        autoClose: false,
      });
      setLoading(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    onSubmit: async () => {
      try {
        setLoading(true);
        if (otp.length === 6) {
          // send data to server
          const { data } = await axiosInstance.get(`${verifyOTPRoute}${otp}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });

          if (data.statusCode === 200 || data.statusCode === 201) {
            toast.dismiss();
            toast.success(t("otpverified"), { autoClose: 1000 });
            navigate(resetPasswordRoute, { state: { otp: data.response } });
          } else {
            toast.dismiss();
            toast.error(t("unexpectedserverresponse"), {
              autoClose: false,
            });
          }
        } else {
          formik.setFieldError("otp", t("otperror"));
        }
      } catch (error) {
        toast.dismiss();
        toast.error(t("otpverifyerror"), {
          autoClose: false,
        });
        setOtp("");
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    Object.keys(formik.touched).forEach((field) => {
      try {
        formik.validateField(field);
      } catch {}
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme.direction]);

  const outerBox = {
    background: theme.palette.whiteblack.main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    //border: `0.5px solid ${theme.palette.componentBackgrounds.main}`,
    borderRadius: 1,
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
    py: 7,
    px: 2,
    maxWidth: 500,
    maxHeight: 525,
    width: "100%",
  };
  const formStyle = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minWidth: "90%",
    gap: 2.5,
  };
  const formStyle2 = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "100%",
  };
  const rootStyle = {
    display: "grid",
    placeItems: "center",
    height: `100vh`,
    background: theme.palette.primary.main,
    backgroundImage: 'url("background.webp")',
    backgroundSize: "cover",
  };

  return email ? (
    <div dir={theme.direction} style={rootStyle}>
      <Paper elevation={1} sx={outerBox}>
        <Box
          sx={{ display: "flex", justifyContent: "center", mb: 2, zoom: 0.8 }}
        >
          <LogoAndText />
        </Box>
        <Box
          sx={{
            display: "flex",
            width: "90%",
            alignItems: "center",
            textAlign: "left",
            mb: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: "1.25rem",
              fontWeight: 800,
              textAlign: "left",
              alignSelf: "center",
              flexGrow: 1,
            }}
          >
            {t("enteryourotp")}
          </Typography>
          <FlipLanguageSwitcher />
        </Box>
        <form style={formStyle2} onSubmit={formik.handleSubmit}>
          <Box sx={formStyle}>
            <Box
              sx={{
                width: "100%",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                mt: 4.6,
                alignItems: "center",
                mb: 2.5,
              }}
            >
              <MuiOtpInput
                width={"90%"}
                autoFocus
                TextFieldsProps={{
                  placeholder: "-",
                  name: "otp",
                  error: formik.errors.otp,
                  onBlur: formik.handleBlur,
                }}
                dir="ltr"
                value={otp}
                length={6}
                onChange={handleChange}
              />
              {formik.touched.otp && formik.errors.otp && (
                <FormHelperText sx={{ mt: 1, color: theme.palette.error.main }}>
                  {formik.errors.otp}
                </FormHelperText>
              )}
            </Box>
          </Box>
          <Box sx={{ width: "90%" }}>
            <LoadingButton
              type="submit"
              loading={loading}
              variant="contained"
              sx={{
                width: "100%",
                textTransform: "none",
                fontWeight: 600,
                fontSize: "1rem",
                my: 2.5,
                py: 1.5,
              }}
            >
              <span>{t("verify")}</span>
            </LoadingButton>
          </Box>
        </form>
        {linkDisable && (
          <Typography>{`00:${time.toString().padStart(2, "0")}`}</Typography>
        )}
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
          <Typography>{`${t("otpnotreceived")}`}&nbsp;</Typography>
          <Button
            onClick={handleResendRequest}
            disabled={linkDisable}
            sx={{
              fontSize: "0.9375rem",
              fontWeight: 700,
              m: 0,
              p: 0,
              textTransform: "none",
              color: theme.palette.whiteblack.contrastText,
            }}
          >
            {t("resendcode")}
          </Button>
        </Box>
      </Paper>
    </div>
  ) : (
    <Box sx={{ height: `100vh` }}>
      <UnAuthorized />
    </Box>
  );
};
export default OTPVerify;
